/* tslint:disable */
/* eslint-disable */
/**
 * EXPItec API
 * The EXPItec API provides an interface to the EXPInet Reisesuche Frontend 
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DictionaryItem } from './DictionaryItem';
import {
    DictionaryItemFromJSON,
    DictionaryItemFromJSONTyped,
    DictionaryItemToJSON,
    DictionaryItemToJSONTyped,
} from './DictionaryItem';

/**
 * 
 * @export
 * @interface Gateway
 */
export interface Gateway {
    /**
     * The airport code
     * @type {string}
     * @memberof Gateway
     */
    airportCode?: string;
    /**
     * The airport name
     * @type {string}
     * @memberof Gateway
     */
    airportName?: string;
    /**
     * List of dictionaryItems containing flightClassCode and flightClassName
     * @type {Array<DictionaryItem>}
     * @memberof Gateway
     */
    flightClass?: Array<DictionaryItem>;
}

/**
 * Check if a given object implements the Gateway interface.
 */
export function instanceOfGateway(value: object): value is Gateway {
    return true;
}

export function GatewayFromJSON(json: any): Gateway {
    return GatewayFromJSONTyped(json, false);
}

export function GatewayFromJSONTyped(json: any, ignoreDiscriminator: boolean): Gateway {
    if (json == null) {
        return json;
    }
    return {
        
        'airportCode': json['airportCode'] == null ? undefined : json['airportCode'],
        'airportName': json['airportName'] == null ? undefined : json['airportName'],
        'flightClass': json['flightClass'] == null ? undefined : ((json['flightClass'] as Array<any>).map(DictionaryItemFromJSON)),
    };
}

export function GatewayToJSON(json: any): Gateway {
    return GatewayToJSONTyped(json, false);
}

export function GatewayToJSONTyped(value?: Gateway | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'airportCode': value['airportCode'],
        'airportName': value['airportName'],
        'flightClass': value['flightClass'] == null ? undefined : ((value['flightClass'] as Array<any>).map(DictionaryItemToJSON)),
    };
}

